module.exports = __webpack_public_path__ + "img/navigationArrowLg.cb825fc9.svg";